import { Card, CardContent } from "src/components/ui/card";
import { Avatar } from "antd";
import { Badge } from "src/components/ui/badge";

export function TeacherCard({ teacher, isSelected, onSelect }) {
  return (
    <Card
      key={teacher?.id}
      className={`cursor-pointer transition-colors ${
        isSelected ? "border-blue-600" : "hover:border-blue-600"
      }`}
      onClick={onSelect}
    >
      <CardContent className="p-6 flex flex-col items-center text-center">
        <Avatar className="h-20 w-20 mb-4" src={teacher?.user?.image}>
          {teacher?.user?.name?.substring(0, 2).toUpperCase()}
        </Avatar>
        <h3 className="text-lg font-semibold">{teacher?.user?.name}</h3>
        <p className="text-muted-foreground">{teacher?.user?.phone}</p>
        <div className="mt-2">
          <Badge
            variant="secondary"
            className="bg-blue-100 text-blue-800 hover:bg-blue-200"
          >
            {teacher?.qualification || "Experienced"}
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
}
